var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "40%",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.resetForm,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("h2", { staticStyle: { "margin-bottom": "2px" } }, [
            _vm._v(_vm._s(_vm.operationTypeText) + "到"),
          ]),
          _c("span", { staticClass: "title_tips" }, [
            _vm._v(
              "点击选择想要" +
                _vm._s(_vm.operationTypeText) +
                "到的目标位置，支持输入题目关键字模糊搜索"
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "flex-row align-center" },
        [
          _c("span", [_vm._v(_vm._s(_vm.operationTypeText) + "到")]),
          _c("el-cascader", {
            staticClass: "ml-10 mr-10",
            attrs: {
              options: _vm.cascaderOptions,
              filterable: true,
              "show-all-levels": false,
              props: {
                expandTrigger: "hover",
              },
            },
            model: {
              value: _vm.symbolFormItemId,
              callback: function ($$v) {
                _vm.symbolFormItemId = $$v
              },
              expression: "symbolFormItemId",
            },
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "80px" },
              model: {
                value: _vm.moveType,
                callback: function ($$v) {
                  _vm.moveType = $$v
                },
                expression: "moveType",
              },
            },
            _vm._l(_vm.moveTypeMap, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm.operationType === "copy"
        ? _c(
            "div",
            { staticClass: "flex-row align-center pt-10" },
            [
              _c("span", [_vm._v("复制次数")]),
              _c("el-input", {
                staticStyle: { width: "100px", "margin-left": "10px" },
                attrs: { placeholder: "＜10次" },
                on: { input: _vm.validateInput },
                model: {
                  value: _vm.frequency,
                  callback: function ($$v) {
                    _vm.frequency = $$v
                  },
                  expression: "frequency",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _vm.batchEditSelectItems },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }